<template>
  <div>
    <h1>Filter Card</h1>
  </div>
</template>

<script>
  import Moment from "moment"

  export default {
    name: 'FilterCard',
    components: {
    },
    data() {
      return {
      }
    },
    props: {
    },
    computed: {
    },
    methods: {
      moment(d) {
          return Moment(d)
      }
    }
  }

</script>
<style lang="scss" scoped>
.btn-container {
  bottom: 10px;
}
</style>
